const styledBy = (property, mapping) => (props) => mapping[props[property]]

export const dateInputStyles = {
  root: {
    width: '100%',
    backgroundColor: 'transparent',
    // margin: styledBy('spaceless', {
    //   undefined: '12px 0',
    //   false: '12px 0',
    //   true: 0,
    // }),
  },
  title: {
    marginBottom: 5,
    fontFamily: 'FSEmeric-Medium',
    // fontSize: 16,
    '&+*': { marginTop: 0, width: '100%' },
  },
  input: {
    backgroundColor: 'white',
    height: styledBy('multiline', {
      undefined: '48px',
      false: '48px',
      true: 'auto',
    }),
  },
}
